var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "roleFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.roleRule,
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 10
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("客户名称")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("英文名称")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataFrom.englishName,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "englishName", $$v);
      },
      expression: "dataFrom.englishName"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "account",
      label: _vm.$t("账号")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 50
    },
    on: {
      input: function ($event) {
        return _vm.handleBlurTrim("account");
      }
    },
    model: {
      value: _vm.dataFrom.account,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "account", $$v);
      },
      expression: "dataFrom.account"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "responsible",
      label: _vm.$t("负责人")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.dataFrom.responsible,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "responsible", $$v);
      },
      expression: "dataFrom.responsible"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "mobile",
      label: _vm.$t("联系方式")
    }
  }, [_c("a-input", {
    on: {
      input: function ($event) {
        _vm.dataFrom.mobile = _vm.dataFrom.mobile.replace(/[^\d]/g, "");
      }
    },
    scopedSlots: _vm._u([{
      key: "addonBefore",
      fn: function () {
        return [_c("a-select", {
          staticStyle: {
            width: "90px"
          },
          attrs: {
            dropdownClassName: "mul-select-dropdown",
            "option-label-prop": "value",
            dropdownMenuStyle: {
              width: "180px"
            }
          },
          on: {
            change: _vm.changeGlobalRoaming
          },
          model: {
            value: _vm.dataFrom.globalRoaming,
            callback: function ($$v) {
              _vm.$set(_vm.dataFrom, "globalRoaming", $$v);
            },
            expression: "dataFrom.globalRoaming"
          }
        }, _vm._l(_vm.globalRoamingOptionData, function (item) {
          return _c("a-select-option", {
            key: item.label,
            attrs: {
              value: item.label,
              title: item.label + _vm.$t(item.value)
            }
          }, [_vm._v(_vm._s(item.label) + "  " + _vm._s(_vm.$t(item.value)))]);
        }), 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.dataFrom.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "mobile", $$v);
      },
      expression: "dataFrom.mobile"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("联系邮箱"),
      prop: "email"
    }
  }, [_c("a-input", {
    on: {
      input: function ($event) {
        return _vm.handleBlurTrim("email");
      }
    },
    model: {
      value: _vm.dataFrom.email,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "email", $$v);
      },
      expression: "dataFrom.email"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "isLicense",
      label: _vm.$t("保险牌照")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.dataFrom.isLicense,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "isLicense", $$v);
      },
      expression: "dataFrom.isLicense"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("无牌照")))]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("有牌照")))])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "appType",
      label: _vm.$t("应用管理")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("应用管理")
    },
    on: {
      change: _vm.appTypeChange
    },
    model: {
      value: _vm.appType,
      callback: function ($$v) {
        _vm.appType = $$v;
      },
      expression: "appType"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("无应用")))]), _c("a-select-option", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("分配现有应用")))])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "countryId",
      label: _vm.$t("业务发生地")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("业务发生地")
    },
    model: {
      value: _vm.dataFrom.countryId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "countryId", $$v);
      },
      expression: "dataFrom.countryId"
    }
  }, _vm._l(_vm.countryOptionData, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1), _vm.appType == "2" ? _c("a-form-model-item", {
    attrs: {
      prop: "appIds",
      label: _vm.$t("分配应用")
    }
  }, [_c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        _vm.dialogVisible = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("新增应用")))]), _vm.mockData.length != 0 ? _c("a-transfer", {
    attrs: {
      "data-source": _vm.mockData,
      titles: [_vm.$t("所有应用"), _vm.$t("分配应用")],
      "list-style": {
        width: "200px",
        height: "300px"
      },
      "target-keys": _vm.targetKeys,
      render: item => item.title,
      "show-search": _vm.showSearch,
      "filter-option": (inputValue, item) => item.title.indexOf(inputValue) !== -1,
      "show-select-all": false
    },
    on: {
      change: _vm.handleChange,
      search: _vm.handleSearch
    },
    scopedSlots: _vm._u([{
      key: "children",
      fn: function ({
        props: {
          filteredItems,
          selectedKeys,
          disabled: listDisabled
        },
        on: {
          itemSelectAll,
          itemSelect
        }
      }) {
        return [_c("a-table", {
          staticClass: "tableTransfer",
          style: {
            pointerEvents: listDisabled ? "none" : null
          },
          attrs: {
            "row-selection": _vm.getRowSelection({
              disabled: listDisabled,
              selectedKeys,
              itemSelectAll,
              itemSelect
            }),
            pagination: false,
            columns: _vm.TableColumns,
            "data-source": filteredItems,
            size: "small",
            "custom-row": ({
              key,
              disabled: itemDisabled
            }) => ({
              on: {
                click: () => {
                  if (itemDisabled || listDisabled) return;
                  itemSelect(key, !selectedKeys.includes(key));
                }
              }
            })
          }
        }, _vm._l(_vm.TableColumns, function (item, i) {
          return _c("span", {
            key: i,
            attrs: {
              slot: item.slots.title
            },
            slot: item.slots.title
          }, [_vm._v(_vm._s(_vm.$t(item.slots.title)))]);
        }), 0)];
      }
    }], null, false, 3221331687)
  }) : _vm._e()], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 14,
        offset: 5
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("下一步")))])], 1)], 1), _vm.dialogVisible ? _c("application-model", {
    attrs: {
      currentRow: {},
      dialogVisible: _vm.dialogVisible,
      tableData: []
    },
    on: {
      ok: _vm.handleOk,
      cancel: function ($event) {
        _vm.dialogVisible = false;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };